module.exports = {
    /*验证手机号码  --验证规则：11位数字，以1开头。*/
    isMobile(params) {
        /*测试数据 13111111111*/
        // let reg = /^1\d{10}$/;
        // let reg = /^13\d{9}|14\d{9}|15\d{9}|16\d{9}|17\d{9}|18\d{9}$/;
        let reg = /^1((34[0-8])|(8\d{2})|(([35][0-35-9]|4[579]|66|7[35678]|9[1389])\d{1}))\d{7}$/
        return reg.test(params)
    },

    /*验证电话号码  
        验证规则：
            区号+号码，区号以0开头，3位或4位
            号码由7位或8位数字组成
            区号与号码之间可以无连接符，也可以“-”连接*/
    isPhone(params) {
        /*测试数据 01088888888,010-88888888,0955-7777777*/
        let reg = /^0\d{2,3}-?\d{7,8}$/;
        return reg.test(params)
    },

    /*验证帐号是否合法  */
    isCheckUser(params) {
        /*测试数据 jihua_cnblogs*/
        //验证规则：字母、数字、下划线组成，字母开头，4-16位。
        // let reg = /^[a-zA-z]\w{3,15}$/; 

        // 验证规则：用户名正则，4到16位（字母，数字，下划线，减号)
        let reg = /^[a-zA-Z0-9_-]{4,16}$/;
        return reg.test(params)
    },

    /*
        验证邮箱
            验证规则：
                姑且把邮箱地址分成“第一部分@第二部分”这样
                第一部分：由字母、数字、下划线、短线“-”、点号“.”组成，
                第二部分：为一个域名，域名由字母、数字、短线“-”、域名后缀组成，
                而域名后缀一般为.xxx或.xxx.xx，一区的域名后缀一般为2-4位，如cn,com,net，现在域名有的也会大于4位
    */
    isEmail(params) {
        /*测试数据 970611994@qq.com*/
        let reg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
        // let reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
        return reg.test(params)
    },


    /*只能是汉字*/
    isOnlyHZ(params) {
        let reg = /^[\u0391-\uFFE5]+$/;
        return reg.test(params)
    },

    /*只能是英文字母 */
    isOnlyZM(params) {
        let reg = /^[a-zA-Z]*$/;
        return reg.test(params)
    },

    /*只能是数字 */
    isOnlySZ(params) {
        let reg = /^[0-9]+$/;
        return reg.test(params)
    },

    /*只能是英文字母或数字  */
    isOnlyZM_SZ(params) {
        let reg = /^[0-9a-zA-Z]*$/;
        return reg.test(params)
    },

    /*只能是英文字母或数字  */
    isOnlyZM_SZ(params) {
        let reg = /^[0-9a-zA-Z]*$/;
        return reg.test(params)
    },

    /**检验时间大小(与当前时间比较) 
     * 
     * 验证规则  如果参数大于当前时间返回true
    */
    isDateBig_small(params) {
        //替换字符，变成标准格式(检验格式为：'2009-12-10')
        let obj_value = params.replace(/-/g, "/");
        let date1 = new Date(Date.parse(obj_value));
        let date2 = new Date();//取今天的日期 
        return date1 > date2
    },

    /**
     * 两次输入密码是否相同  
     */
    isPasswordNewOrOld(p1, p2) {
        return p1 == p2
    },

    /**
     * 验证身份证号
     */
    isCardID(params) {
        // let reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        // let reg =  /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i;
        // return reg.test(params)

        let _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
        let _IDre15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/
        // 校验身份证：
        if (_IDRe18.test(params) || _IDre15.test(params)) {
            console.log(' 验证通过 ')
            return true
        } else {
            console.log(' 验证未通过 ')
            return false
        }
    },
    // 银行卡号
    cardId(params) {
        let reg = /^([1-9]{1})(\d{14}|\d{18})$/;
        return reg.test(params)
    },

    /**
     *  QQ号码
     *      规则：5至11位
     */
    isQQNumber(params) {
        let reg = /^[1-9][0-9]{4,10}$/;
        return reg.test(params)
    },


    /**
     *  微信号
     *    微信号正则，6至20位，以字母开头，字母，数字，减号，下划线
     */
    isWXNumber(params) {
        let reg = /^[a-zA-Z]([-_a-zA-Z0-9]{5,19})+$/;
        return reg.test(params)
    },

    /**
    *  车牌号
    */
    isCartNumber(params) {
        console.log(this);
        let reg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$/;
        return reg.test(params)
    },
}